import React from 'react';
import { Users, Ban, ArrowDownCircle, BadgeDollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function WhyTokotetaSection() {
  const {
    t
  } = useLanguage();
  const cards = [{
    icon: <Users size={32} className="text-primary" data-id="element-306" />,
    title: t.whyTokoteta.cards.community.title,
    desc: t.whyTokoteta.cards.community.desc
  }, {
    icon: <Ban size={32} className="text-primary" data-id="element-307" />,
    title: t.whyTokoteta.cards.noAds.title,
    desc: t.whyTokoteta.cards.noAds.desc
  }, {
    icon: <ArrowDownCircle size={32} className="text-primary" data-id="element-308" />,
    title: t.whyTokoteta.cards.lowFee.title,
    desc: t.whyTokoteta.cards.lowFee.desc
  }, {
    icon: <BadgeDollarSign size={32} className="text-primary" data-id="element-309" />,
    title: t.whyTokoteta.cards.earn.title,
    desc: t.whyTokoteta.cards.earn.desc
  }];
  return <section id="why-different" className="py-24 bg-gradient-to-b from-white to-secondary/50" data-id="element-310">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
        <div className="text-center mb-16" data-id="element-312">
          <p className="text-primary font-bold tracking-widest text-sm uppercase mb-4" data-id="element-313">
            {t.whyTokoteta.label}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-text-main" data-id="element-314">
            {t.whyTokoteta.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-315">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex items-start gap-6 hover:shadow-md transition-shadow" data-id="element-316">
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center shrink-0" data-id="element-317">
                {card.icon}
              </div>
              <div data-id="element-318">
                <h3 className="text-xl font-bold text-text-main mb-2" data-id="element-319">
                  {card.title}
                </h3>
                <p className="text-text-muted leading-relaxed" data-id="element-320">{card.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}